module.exports = __webpack_public_path__ + "img/uv.2a2f56f4.svg";